/**
 * Ritual erfüllt — Klaviyo Track + Identify via _learnq (URL params ?email, ?day).
 * Requires Klaviyo onsite.js (theme layout).
 */
(function () {
  const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function todayISO() {
    return new Date().toISOString().split('T')[0];
  }

  function trackRitualInKlaviyo(email, dayNumber, today) {
    var _learnq = window._learnq || [];

    _learnq.push([
      'identify',
      {
        $email: email,
        last_ritual_date: today,
        current_day: dayNumber,
      },
    ]);

    _learnq.push([
      'track',
      'Ritual Erfuellt',
      {
        day_number: dayNumber,
        date: today,
      },
    ]);
  }

  function initRitual(root) {
    const totalDays = parseInt(root.dataset.totalDays, 10) || 30;
    const dayEl = root.querySelector('[data-ritual-day]');
    const params = new URLSearchParams(window.location.search);
    const email = (params.get('email') || '').trim();
    const dayRaw = params.get('day');
    const parsedDay = parseInt(dayRaw, 10);
    const hasValidDay = !Number.isNaN(parsedDay) && parsedDay >= 1 && parsedDay <= totalDays;
    const day = hasValidDay ? parsedDay : 0;

    if (dayEl && hasValidDay) {
      const dayTag = root.dataset.dayTag || 'Tag';
      const dayVon = root.dataset.dayVon || 'von';
      dayEl.textContent = dayTag + ' ' + day + ' ' + dayVon + ' ' + totalDays;
      dayEl.hidden = false;
    }

    if (!email || !EMAIL_RE.test(email)) {
      return;
    }

    const today = todayISO();
    const dayNumber = day || 1;

    trackRitualInKlaviyo(email, dayNumber, today);
  }

  function boot() {
    document.querySelectorAll('[data-ritual-root]').forEach(initRitual);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
